enum ClientCapability {
  None = 0,
  PassCustomCss = 1,
  MakeMaitredRequests = 2,
  PassCustomFonts = 3,
  EpsonSetFontCommand = 4,
  SendBiteLogs = 5,
  PerformRefunds = 6,
  ProvidesHardwareConfig = 7,
  UsesNewGcnEventFormat = 8,
  SupportsPartialCreditCallRefundsIos = 9,
  GiftCards = 10,
  OpenRefundsNative = 11,
  SendJsonOverBridge = 12,
  ProperErrorFormat = 13,
  OrdersApiV2 = 14,
  ReducedViewportHeight = 15,
}

export { ClientCapability };
